exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".input-area select[data-v-69589883]:disabled{background-color:#fff!important;color:#222!important;-webkit-text-fill-color:#222!important;opacity:1!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-69589883","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/main/member/ACT/InActJnlDetail.vue
// module id = 774
// module chunks = 6